import React from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import { Box, Checkbox, IconButton } from "@mui/material";
import AccountBoxIcon from "@mui/icons-material/AccountBox";

import {
  CENTS_IN_DOLLAR,
  HOURS_12_FORMAT_WITH_DATE,
  STATUS_COLORS_OPACITY,
} from "../../../../../constants";
import { useComplianceSearchContext } from "../../../../../context";
import { CopyToClipboard } from "../../../../../components/ui";
import { IntlFormatUSD } from "../../../../../utils";

const TableBody = (): React.ReactElement => {
  const { data } = useSelector((state) => state.complianceSearch.accounts_table);
  const {
    accounts_table: { selectedRows, setSelectedRows },
  } = useComplianceSearchContext();

  const handleRowClick = (id: number) => {
    if (selectedRows.find((r) => r.id === id)) {
      setSelectedRows(selectedRows.filter((r) => r.id !== id));
    } else {
      setSelectedRows([...selectedRows, { id }]);
    }
  };

  const handleClickProfileIcon = (id: number) => window.open(`#/customer/${id}`, "_blank");

  return (
    <tbody>
      {data.rows.map((r) => {
        const isSelectedRow = selectedRows.find((selected) => selected.id === r.id);

        return (
          <Box
            component="tr"
            sx={{
              ...(isSelectedRow && {
                "&:nth-child(even) td": {
                  backgroundColor: `${STATUS_COLORS_OPACITY.tango} !important`,
                },
                "& td": {
                  backgroundColor: STATUS_COLORS_OPACITY.tango,
                },
              }),
            }}
            key={r.id}
          >
            <td>
              <Checkbox
                checked={!!isSelectedRow}
                color="default"
                onClick={() => handleRowClick(r.id)}
              />
            </td>
            <td>{r.id}</td>
            <td>{IntlFormatUSD(r.total_sales / CENTS_IN_DOLLAR)}</td>
            <td>
              <CopyToClipboard value={r.name} />
            </td>
            <Box component="td" display="flex" alignItems="center">
              <IconButton onClick={() => handleClickProfileIcon(r.id)}>
                <AccountBoxIcon />
              </IconButton>
              <CopyToClipboard value={r.email} />
            </Box>
            <td>
              <CopyToClipboard value={r.reg_ip} />
            </td>
            <td>
              <CopyToClipboard value={r.phone} />
            </td>
            <td>{r.country.name}</td>
            <td>{r.zip}</td>
            <td>{r.city}</td>
            <td>{r.address}</td>
            <td>{moment(r.joined).utc().format(HOURS_12_FORMAT_WITH_DATE)}</td>
          </Box>
        );
      })}
    </tbody>
  );
};

export default TableBody;
